import { render } from "./EditEntry.vue?vue&type=template&id=5b39be3c"
import script from "./EditEntry.vue?vue&type=script&lang=js"
export * from "./EditEntry.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__